import { invokeUtilContainerHasSize } from "./container";
import { devInfo } from "@/utils/device";
import router from "@/router";
/**
 * JS 调用 APP
 * @param data
 * @param data.method 调用方法,与 APP 协商定义
 * @param data.data   调用时传的数据
 */
export const JSCallAPP = <T>(data: { method: string; data?: T }) => {
  try {
    const sendData = JSON.stringify(data);

    console.log("JSCallAPP: ", JSON.stringify(data));

    if(devInfo.isDingTalkDevice){
      console.log("--=-=-=-",router)
      const tmp = {...data.data} as any ;
      const pathTmp = tmp.url;
      delete tmp.url
      router.push({path:pathTmp,query:tmp}) 
    }else{
      if (typeof window.JSCallApp !== undefined) {
        window.JSCallApp.postMessage(sendData);
      } else {
        console.log("JSCallApp 方法未定义");
      }
    }

    
  } catch (e) {
    console.error(e);
  }
};

/**
 * APP 调用  JS
 * TODO: 实现 remove 方法以便移除监听，目前只有一个页面不需要
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type callback = (data: any) => void;
const methodCallMap = new Map<string, callback[]>();

const on = <T>(method: string, callback: (data: T) => void) => {
  if (!methodCallMap.has(method)) {
    methodCallMap.set(method, []);
  }
  methodCallMap.get(method)?.push(callback);
};

const start = () => {
  // 定义 APP 调用 JS 的方法
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.APPCallJS = (sendData: any) => {
    console.log("APPCallJS: ", JSON.stringify(sendData));

    invokeUtilContainerHasSize(() => {
      const { method, data } = sendData;
      methodCallMap.get(method)?.forEach((callback) => callback(data));
    });
  };
};

export const APPCallJS = {
  start,
  on,
};
